import React from 'react';

export default function AttendanceBanner({ att }) {
  const rawStatus = (att && att.status) ?? '';
  const statusNorm = (() => {
    const s = String(rawStatus || '').trim().toLowerCase();
    // Accept plain values (present/late/absent) and enum-ish strings like "AttendanceStatus.PRESENT".
    const lastToken = s.includes('.') ? s.split('.').pop() : s;
    if (lastToken === 'present' || lastToken.includes('present')) return 'present';
    if (lastToken === 'late' || lastToken.includes('late')) return 'late';
    if (lastToken === 'absent' || lastToken.includes('absent')) return 'absent';
    return '';
  })();
  const note = (att && (att.notes ?? att.note) ? String(att.notes ?? att.note).trim() : '') || '';
  const meta = (() => {
    if (statusNorm === 'present') {
      return {
        label: 'Geldi',
        iconColor: '#059669',
        pillBg: '#ECFDF5', pillBorder: '#A7F3D0', pillColor: '#065F46',
        bannerBg: '#F4FBF8', bannerBorder: '#D5F5E6', titleColor: '#064E3B', textColor: '#064E3B',
        icon: (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ),
      };
    }
    if (statusNorm === 'late') {
      return {
        label: 'Geç kaldı',
        iconColor: '#B45309',
        pillBg: '#FFFBEB', pillBorder: '#FDE68A', pillColor: '#92400E',
        bannerBg: '#FFF9ED', bannerBorder: '#FFEFC7', titleColor: '#7C2D12', textColor: '#7C2D12',
        icon: (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
          </svg>
        ),
      };
    }
    if (statusNorm === 'absent') {
      return {
        label: 'Gelmedi',
        iconColor: '#B91C1C',
        pillBg: '#FEF2F2', pillBorder: '#FECACA', pillColor: '#991B1B',
        bannerBg: '#FFF6F6', bannerBorder: '#FFE1E1', titleColor: '#7F1D1D', textColor: '#7F1D1D',
        icon: (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ),
      };
    }
    // default: no record
    return {
      label: 'Kayıt yok',
      iconColor: '#64748b',
      pillBg: '#EAF0FF', pillBorder: '#D9E2FF', pillColor: '#475569',
      bannerBg: '#F8FAFF', bannerBorder: '#E6EFFD', titleColor: '#0F1E56', textColor: '#334155',
      icon: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      ),
    };
  })();

  const title = statusNorm === 'present' ? 'Bugün okulda'
    : statusNorm === 'late' ? 'Bugün geç geldi'
      : statusNorm === 'absent' ? 'Bugün okulda değil' : 'Bugünkü yoklama yok';

  return (
    <div role="region" aria-label="Bugünkü Yoklama" style={{
      display:'flex', alignItems:'center', gap:10, minHeight:48, boxSizing:'border-box',
      background:meta.bannerBg, border:'1px solid '+meta.bannerBorder, borderRadius:12, padding:'6px 10px',
    }}>
      <span style={{ width:30, height:30, borderRadius:'50%', background:meta.pillBg,
        color:meta.iconColor, display:'grid', placeItems:'center', flex:'0 0 auto' }}>{meta.icon}</span>
      <div style={{ minWidth:0 }}>
        <div style={{ color:meta.titleColor, fontSize:14, fontWeight:800, lineHeight:1.2 }}>{title}</div>
        <div style={{ color:meta.textColor, fontSize:11, lineHeight:1.2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {note || 'Öğretmen yoklaması'}
        </div>
      </div>
    </div>
  );
}
